module.exports = __webpack_public_path__ + "static/media/onboarding mock.56db298b.png";